'use strict';

const directionsIconSvg = `
  <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M17.5867 9.24375L17.9403 8.8902V8.8902L17.5867 9.24375ZM16.4117 9.24375L16.7653 9.59731L16.7675 9.59502L16.4117 9.24375ZM8.91172 16.7437L8.55817 16.3902L8.91172 16.7437ZM8.91172 17.9229L8.55817 18.2765L8.55826 18.2766L8.91172 17.9229ZM16.4117 25.4187H16.9117V25.2116L16.7652 25.0651L16.4117 25.4187ZM16.4117 25.4229H15.9117V25.63L16.0582 25.7765L16.4117 25.4229ZM25.0909 17.9229L25.4444 18.2765L25.4467 18.2742L25.0909 17.9229ZM25.4403 16.3902L17.9403 8.8902L17.2332 9.5973L24.7332 17.0973L25.4403 16.3902ZM17.9403 8.8902C17.4213 8.3712 16.5737 8.3679 16.0559 8.89248L16.7675 9.59502C16.8914 9.4696 17.1022 9.4663 17.2332 9.5973L17.9403 8.8902ZM16.0582 8.8902L8.55817 16.3902L9.26527 17.0973L16.7653 9.5973L16.0582 8.8902ZM8.55817 16.3902C8.0379 16.9105 8.0379 17.7562 8.55817 18.2765L9.26527 17.5694C9.13553 17.4396 9.13553 17.227 9.26527 17.0973L8.55817 16.3902ZM8.55826 18.2766L16.0583 25.7724L16.7652 25.0651L9.26517 17.5693L8.55826 18.2766ZM15.9117 25.4187V25.4229H16.9117V25.4187H15.9117ZM16.0582 25.7765C16.5784 26.2967 17.4242 26.2967 17.9444 25.7765L17.2373 25.0694C17.1076 25.1991 16.895 25.1991 16.7653 25.0694L16.0582 25.7765ZM17.9444 25.7765L25.4444 18.2765L24.7373 17.5694L17.2373 25.0694L17.9444 25.7765ZM25.4467 18.2742C25.9631 17.7512 25.9663 16.9096 25.438 16.3879L24.7354 17.0995C24.8655 17.2279 24.8687 17.4363 24.7351 17.5716L25.4467 18.2742Z" fill="#7e7efd"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M19 19.8333V17.75H15.6667V20.25H14V16.9167C14 16.4542 14.3708 16.0833 14.8333 16.0833H19V14L21.9167 16.9167L19 19.8333Z" fill="#7e7efd"/>
    <circle cx="17" cy="17" r="16.5" stroke="#7e7efd"/>
  </svg>
`;

const placeBannerSvg = `
  <svg width="23" height="32" viewBox="0 0 23 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M22.9976 11.5003C22.9976 13.2137 22.7083 14.9123 21.8025 16.7056C18.6321 22.9832 12.7449 24.3314 12.2758 30.7085C12.2448 31.1294 11.9286 31.4744 11.4973 31.4744C11.0689 31.4744 10.7527 31.1294 10.7218 30.7085C10.2527 24.3314 4.3655 22.9832 1.19504 16.7056C0.289306 14.9123 0 13.2137 0 11.5003C0 5.13275 5.14557 0 11.5003 0C17.852 0 22.9976 5.13275 22.9976 11.5003Z" fill="#4285F4"/>
    <path fill-rule="evenodd" clip-rule="evenodd" transform="translate(5.5,5.5)" d="M6 8.84091L9.708 11L8.724 6.92961L12 4.19158L7.6856 3.83881L6 0L4.3144 3.83881L0 4.19158L3.276 6.92961L2.292 11L6 8.84091Z" fill="#FBE15C"/>
  </svg>
`;

function escapeHtml(value) {
  return String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function escapeAttribute(value) {
  return escapeHtml(value);
}

function getHttpUrl(value) {
  try {
    const url = new URL(value);
    return ['http:', 'https:'].includes(url.protocol) ? url : null;
  } catch (error) {
    return null;
  }
}

function sanitizeGoogleAttribution(attribution) {
  const template = document.createElement('template');
  template.innerHTML = String(attribution ?? '');

  const sanitizeNode = function (node) {
    if (node.nodeType === Node.TEXT_NODE) {
      return escapeHtml(node.textContent);
    }

    if (node.nodeType !== Node.ELEMENT_NODE) {
      return '';
    }

    const children = Array.from(node.childNodes).map(sanitizeNode).join('');
    if (node.tagName.toLowerCase() !== 'a') {
      return children;
    }

    const url = getHttpUrl(node.getAttribute('href'));
    if (!url) {
      return children;
    }

    return `<a href="${escapeAttribute(url.href)}" target="_blank" rel="noopener noreferrer">${children}</a>`;
  };

  return Array.from(template.content.childNodes).map(sanitizeNode).join('');
}

function renderResultItems({ locations, showDirectionsButton }) {
  return locations.map((location) => `
    <li class="location-result" data-location-index="${location.index}">
      <button class="select-location" data-store-locator-select-location>
        <h2 class="name">${escapeHtml(location.title)}</h2>
      </button>
      <div class="address">${escapeHtml(location.address1)}<br>${escapeHtml(location.address2)}</div>
      <button class="details-button" data-store-locator-details-button>View details</button>
      ${location.travelDistanceText ? `<div class="distance">${escapeHtml(location.travelDistanceText)}</div>` : ''}
      ${showDirectionsButton ? `<button class="show-directions" data-store-locator-show-directions title="Show directions to this location" aria-label="Show directions to this location">${directionsIconSvg}</button>` : ''}
    </li>
  `).join('');
}

function renderStars(place) {
  if (!place?.rating) return '';

  const fullStars = (place.fullStarIcons || []).map(() => '<img src="https://fonts.gstatic.com/s/i/googlematerialicons/star/v15/24px.svg" alt="" class="star-icon"/>').join('');
  const halfStars = (place.halfStarIcons || []).map(() => '<img src="https://fonts.gstatic.com/s/i/googlematerialicons/star_half/v17/24px.svg" alt="" class="star-icon"/>').join('');
  const emptyStars = (place.emptyStarIcons || []).map(() => '<img src="https://fonts.gstatic.com/s/i/googlematerialicons/star_outline/v9/24px.svg" alt="" class="star-icon"/>').join('');

  return `<span class="star-rating-numeric">${escapeHtml(place.rating)}</span><span>${fullStars}${halfStars}${emptyStars}</span>`;
}

function renderLocationDetails({ location, place = {} }) {
  const placeUrl = getHttpUrl(place.url);
  const websiteUrl = getHttpUrl(place.website);
  const reviewsLink = place.user_ratings_total
    ? placeUrl ? `<a href="${escapeAttribute(placeUrl.href)}" target="_blank">${escapeHtml(place.user_ratings_total)} reviews</a>` : `${escapeHtml(place.user_ratings_total)} reviews`
    : placeUrl ? `<a href="${escapeAttribute(placeUrl.href)}" target="_blank">See on Google Maps</a>` : '';
  const priceLevel = place.price_level
    ? `&bull;<span class="price-dollars">${(place.dollarSigns || []).map(() => '$').join('')}</span>`
    : '';
  const hours = place.opening_hours
    ? `<div class="hours contact"><img src="https://fonts.gstatic.com/s/i/googlematerialicons/schedule/v12/24px.svg" alt="Opening hours" class="icon"/><div class="right">${(place.openingHoursSummary || []).map(({ days, hours: weekdayHours }) => `<div><span class="weekday">${escapeHtml(days)}</span><span class="weekday-hours">${escapeHtml(weekdayHours)}</span></div>`).join('')}</div></div>`
    : '';
  const website = websiteUrl
    ? `<div class="website contact"><img src="https://fonts.gstatic.com/s/i/googlematerialicons/public/v10/24px.svg" alt="Website" class="icon"/><div class="right"><a href="${escapeAttribute(websiteUrl.href)}" target="_blank">${escapeHtml(place.websiteDomain)}</a></div></div>`
    : '';
  const phone = place.formatted_phone_number
    ? `<div class="phone contact"><img src="https://fonts.gstatic.com/s/i/googlematerialicons/phone/v10/24px.svg" alt="Phone number" class="icon"/><div class="right">${escapeHtml(place.formatted_phone_number)}</div></div>`
    : '';
  const attributions = place.html_attributions
    ? place.html_attributions.map((attribution) => `<p class="attribution">${sanitizeGoogleAttribution(attribution)}</p>`).join('')
    : '';

  return `
    <button class="back-button" data-store-locator-back-button><img class="icon" src="https://fonts.gstatic.com/s/i/googlematerialicons/arrow_back/v11/24px.svg" alt=""/>Back</button>
    <header><div class="banner">${placeBannerSvg}</div><h2>${escapeHtml(location.title)}</h2></header>
    ${location.travelDistanceText ? `<div class="distance">${escapeHtml(location.travelDistanceText)} away</div>` : ''}
    <div class="address">${escapeHtml(location.address1)}<br>${escapeHtml(location.address2)}</div>
    <div class="atmosphere">${renderStars(place)}${reviewsLink}${priceLevel}</div>
    <hr/>
    ${hours}${website}${phone}${attributions}
  `;
}


    /** Hide a DOM element. */
    function hideElement(el) {
        el.style.display = 'none';
    }

    /** Show a DOM element that has been hidden. */
    function showElement(el) {
        el.style.display = 'block';
    }

    /**
     * Defines an instance of the Locator+ solution, to be instantiated
     * when the Maps library is loaded.
     */
    function LocatorPlus(configuration, rootEl) {
        const locator = this;

        locator.locations = configuration.locations || [];
        locator.capabilities = configuration.capabilities || {};
        locator.rootEl = rootEl;
        locator.mapEventListeners = [];
        locator.autocomplete = null;
        locator.directionsRenderer = null;
        locator.markers = [];
        locator.isDestroyed = false;

        const mapEl = rootEl.querySelector('[data-store-locator-map]');
        const panelEl = rootEl.querySelector('[data-store-locator-panel]');
        locator.panelListEl = rootEl.querySelector('[data-store-locator-panel-list]');
        const sectionNameEl =
            rootEl.querySelector('[data-store-locator-results-section-name]');
        const resultsContainerEl = rootEl.querySelector('[data-store-locator-results-list]');
        locator.searchLocation = null;
        locator.searchLocationMarker = null;
        locator.selectedLocationIdx = null;
        locator.userCountry = null;

        // Initialize the map -------------------------------------------------------
        locator.map = new google.maps.Map(mapEl, configuration.mapOptions);

        // Store selection.
        const selectResultItem = function (locationIdx, panToMarker, scrollToResult) {
            locator.selectedLocationIdx = locationIdx;
            for (let locationElem of resultsContainerEl.children) {
                locationElem.classList.remove('selected');
                if (getResultIndex(locationElem) === locator.selectedLocationIdx) {
                    locationElem.classList.add('selected');
                    if (scrollToResult) {
                        panelEl.scrollTop = locationElem.offsetTop;
                    }
                }
            }
            if (panToMarker && (locationIdx != null)) {
                locator.map.panTo(locator.locations[locationIdx].coords);
            }
        };

        // Create a marker for each location.
        const markers = locator.locations.map(function (location, index) {
            const marker = new google.maps.Marker({
                position: location.coords,
                map: locator.map,
                title: location.title,
            });
            locator.mapEventListeners.push(marker.addListener('click', function () {
                selectResultItem(index, false, true);
            }));
            return marker;
        });
        locator.markers = markers;

        // Fit map to marker bounds.
        locator.updateBounds = function () {
            const bounds = new google.maps.LatLngBounds();
            if (locator.searchLocationMarker) {
                bounds.extend(locator.searchLocationMarker.getPosition());
            }
            for (let i = 0; i < markers.length; i++) {
                bounds.extend(markers[i].getPosition());
            }
            locator.map.fitBounds(bounds);
        };
        if (locator.locations.length) {
            locator.updateBounds();
        }

        // Get the distance of a store location to the user's location,
        // used in sorting the list.
        const getLocationDistance = function (location) {
            if (!locator.searchLocation) return null;

            // Use travel distance if available (from Distance Matrix).
            if (location.travelDistanceValue != null) {
                return location.travelDistanceValue;
            }

            // Fall back to straight-line distance.
            return google.maps.geometry.spherical.computeDistanceBetween(
                new google.maps.LatLng(location.coords),
                locator.searchLocation.location);
        };

        // Render the results list --------------------------------------------------
        const getResultIndex = function (elem) {
            return parseInt(elem.getAttribute('data-location-index'), 10);
        };

        locator.renderResultsList = function () {
            if (locator.isDestroyed) return;

            let locations = locator.locations.slice();

            for (let i = 0; i < locations.length; i++) {
                locations[i].index = i;
            }
            if (locator.searchLocation) {
                sectionNameEl.textContent =
                    'Nearest locations (' + locations.length + ')';
                locations.sort(function (a, b) {
                    return getLocationDistance(a) - getLocationDistance(b);
                });
            } else {
                sectionNameEl.textContent = `All locations (${locations.length})`;
            }
            const resultItemContext = {
                locations: locations,
                showDirectionsButton: !!locator.searchLocation,
            };

            resultsContainerEl.innerHTML = renderResultItems(resultItemContext);
            for (let item of resultsContainerEl.children) {
                const resultIndex = getResultIndex(item);
                if (resultIndex === locator.selectedLocationIdx) {
                    item.classList.add('selected');
                }

                const resultSelectionHandler = function () {
                    if (resultIndex !== locator.selectedLocationIdx) {
                        locator.clearDirections();
                    }
                    selectResultItem(resultIndex, true, false);
                };

                item.querySelector('[data-store-locator-select-location]')
                    .addEventListener('click', function (e) {
                        resultSelectionHandler();
                        e.stopPropagation();
                    });

                item.querySelector('[data-store-locator-details-button]')
                    .addEventListener('click', function () {
                        locator.showDetails(resultIndex);
                    });

                if (resultItemContext.showDirectionsButton) {
                    item.querySelector('[data-store-locator-show-directions]')
                        .addEventListener('click', function (e) {
                            selectResultItem(resultIndex, false, false);
                            locator.updateDirections();
                            e.stopPropagation();
                        });
                }
            }
        };

        // Optional capability initialization --------------------------------------
        initializeSearchInput(locator);
        initializeDistanceMatrix(locator);
        initializeDirections(locator);
        initializeDetails(locator);

        // Initial render of results -----------------------------------------------
        locator.renderResultsList();

        locator.destroy = function () {
            locator.isDestroyed = true;
            locator.mapEventListeners.forEach(function (listener) {
                google.maps.event.removeListener(listener);
            });
            locator.mapEventListeners = [];

            if (locator.autocomplete) {
                google.maps.event.clearInstanceListeners(locator.autocomplete);
                locator.autocomplete.unbindAll();
                locator.autocomplete = null;
            }

            if (locator.searchLocationMarker) {
                locator.searchLocationMarker.setMap(null);
                locator.searchLocationMarker = null;
            }

            locator.markers.forEach(function (marker) {
                google.maps.event.clearInstanceListeners(marker);
                marker.setMap(null);
            });
            locator.markers = [];

            if (locator.directionsRenderer) {
                locator.directionsRenderer.setMap(null);
                locator.directionsRenderer = null;
            }

            if (locator.map) {
                google.maps.event.clearInstanceListeners(locator.map);
                locator.map = null;
            }
        };
    }

    /** When the search input capability is enabled, initialize it. */
    function initializeSearchInput(locator) {
        const geocodeCache = new Map();
        const geocoder = new google.maps.Geocoder();

        const searchInputEl = locator.rootEl.querySelector('[data-store-locator-search-input]');
        const searchButtonEl = locator.rootEl.querySelector('[data-store-locator-search-button]');

        const updateSearchLocation = function (address, location) {
            if (locator.isDestroyed) return;

            if (locator.searchLocationMarker) {
                locator.searchLocationMarker.setMap(null);
            }
            if (!location) {
                locator.searchLocation = null;
                return;
            }
            locator.searchLocation = { 'address': address, 'location': location };
            locator.searchLocationMarker = new google.maps.Marker({
                position: location,
                map: locator.map,
                title: 'My location',
                icon: {
                    path: google.maps.SymbolPath.CIRCLE,
                    scale: 12,
                    fillColor: '#3367D6',
                    fillOpacity: 0.5,
                    strokeOpacity: 0,
                }
            });

            // Update the locator's idea of the user's country, used for units. Use
            // `formatted_address` instead of the more structured `address_components`
            // to avoid an additional billed call.
            const normalizedAddress = address.toLowerCase();
            locator.userCountry = normalizedAddress.includes('usa') || normalizedAddress.includes('united states')
                ? 'USA'
                : null;

            // Update map bounds to include the new location marker.
            locator.updateBounds();

            // Update the result list so we can sort it by proximity.
            locator.renderResultsList();

            locator.updateTravelTimes();

            locator.clearDirections();
        };

        const geocodeSearch = function (query) {
            if (!query) {
                return;
            }

            const handleResult = function (geocodeResult) {
                searchInputEl.value = geocodeResult.formatted_address;
                updateSearchLocation(
                    geocodeResult.formatted_address, geocodeResult.geometry.location);
            };

            if (geocodeCache.has(query)) {
                handleResult(geocodeCache.get(query));
                return;
            }
            const request = { address: query, bounds: locator.map.getBounds() };
            geocoder.geocode(request, function (results, status) {
                if (locator.isDestroyed) return;

                if (status === 'OK') {
                    if (results.length > 0) {
                        const result = results[0];
                        geocodeCache.set(query, result);
                        handleResult(result);
                    }
                }
            });
        };

        // Set up geocoding on the search input.
        searchButtonEl.addEventListener('click', function () {
            geocodeSearch(searchInputEl.value.trim());
        });

        // Initialize Autocomplete.
        initializeSearchInputAutocomplete(
            locator, searchInputEl, geocodeSearch, updateSearchLocation);
    }

    /** Add Autocomplete to the search input. */
    function initializeSearchInputAutocomplete(
        locator, searchInputEl, fallbackSearch, searchLocationUpdater) {
        // Set up Autocomplete on the search input. Bias results to map viewport.
        const autocomplete = new google.maps.places.Autocomplete(searchInputEl, {
            types: ['geocode'],
            fields: ['place_id', 'formatted_address', 'geometry.location']
        });
        autocomplete.bindTo('bounds', locator.map);
        locator.autocomplete = autocomplete;
        locator.mapEventListeners.push(autocomplete.addListener('place_changed', function () {
            if (locator.isDestroyed) return;

            const placeResult = autocomplete.getPlace();
            if (!placeResult.geometry) {
                // Hitting 'Enter' without selecting a suggestion will result in a
                // placeResult with only the text input value as the 'name' field.
                fallbackSearch(placeResult.name);
                return;
            }
            searchLocationUpdater(
                placeResult.formatted_address, placeResult.geometry.location);
        }));
    }

    /** Initialize Distance Matrix for the locator. */
    function initializeDistanceMatrix(locator) {
        const distanceMatrixService = new google.maps.DistanceMatrixService();

        // Annotate travel times to the selected location using Distance Matrix.
        locator.updateTravelTimes = function () {
            if (!locator.searchLocation) return;

            const units = (locator.userCountry === 'USA') ?
                google.maps.UnitSystem.IMPERIAL :
                google.maps.UnitSystem.METRIC;
            const request = {
                origins: [locator.searchLocation.location],
                destinations: locator.locations.map(function (x) {
                    return x.coords;
                }),
                travelMode: google.maps.TravelMode.DRIVING,
                unitSystem: units,
            };
            const callback = function (response, status) {
                if (locator.isDestroyed) return;

                if (status === 'OK') {
                    const distances = response.rows[0].elements;
                    for (let i = 0; i < distances.length; i++) {
                        const distResult = distances[i];
                        let travelDistanceText, travelDistanceValue;
                        if (distResult.status === 'OK') {
                            travelDistanceText = distResult.distance.text;
                            travelDistanceValue = distResult.distance.value;
                        }
                        const location = locator.locations[i];
                        location.travelDistanceText = travelDistanceText;
                        location.travelDistanceValue = travelDistanceValue;
                    }

                    // Re-render the results list, in case the ordering has changed.
                    locator.renderResultsList();
                }
            };
            distanceMatrixService.getDistanceMatrix(request, callback);
        };
    }

    /** Initialize Directions service for the locator. */
    function initializeDirections(locator) {
        const directionsCache = new Map();
        const directionsService = new google.maps.DirectionsService();
        const directionsRenderer = new google.maps.DirectionsRenderer({
            suppressMarkers: true,
        });
        locator.directionsRenderer = directionsRenderer;

        // Update directions displayed from the search location to
        // the selected location on the map.
        locator.updateDirections = function () {
            if (!locator.searchLocation || (locator.selectedLocationIdx == null)) {
                return;
            }
            const cacheKey = JSON.stringify(
                [locator.searchLocation.location, locator.selectedLocationIdx]);
            if (directionsCache.has(cacheKey)) {
                const directions = directionsCache.get(cacheKey);
                directionsRenderer.setMap(locator.map);
                directionsRenderer.setDirections(directions);
                return;
            }
            const request = {
                origin: locator.searchLocation.location,
                destination: locator.locations[locator.selectedLocationIdx].coords,
                travelMode: google.maps.TravelMode.DRIVING
            };
            directionsService.route(request, function (response, status) {
                if (locator.isDestroyed) return;

                if (status === 'OK') {
                    directionsRenderer.setMap(locator.map);
                    directionsRenderer.setDirections(response);
                    directionsCache.set(cacheKey, response);
                }
            });
        };

        locator.clearDirections = function () {
            directionsRenderer.setMap(null);
        };
    }

    /** Initialize Place Details service and UI for the locator. */
    function initializeDetails(locator) {
        const panelDetailsEl = locator.rootEl.querySelector('[data-store-locator-panel-details]');
        const detailsService = new google.maps.places.PlacesService(locator.map);

        const renderDetails = function (context) {
            panelDetailsEl.innerHTML = renderLocationDetails(context);
            panelDetailsEl.querySelector('[data-store-locator-back-button]')
                .addEventListener('click', hideDetails);
        };

        const hideDetails = function () {
            showElement(locator.panelListEl);
            hideElement(panelDetailsEl);
        };

        locator.showDetails = function (locationIndex) {
            const location = locator.locations[locationIndex];
            const context = { location };

            const showRenderedDetails = function (detailsContext) {
                renderDetails(detailsContext);
                hideElement(locator.panelListEl);
                showElement(panelDetailsEl);
            };

            // Helper function to create a fixed-size array.
            const initArray = function (arraySize) {
                const array = [];
                while (array.length < arraySize) {
                    array.push(0);
                }
                return array;
            };

            if (location.placeId) {
                const request = {
                    placeId: location.placeId,
                    fields: [
                        'formatted_phone_number', 'website', 'opening_hours', 'url',
                        'utc_offset_minutes', 'price_level', 'rating', 'user_ratings_total'
                    ]
                };
                detailsService.getDetails(request, function (place, status) {
                    if (locator.isDestroyed) return;

                    if (status == google.maps.places.PlacesServiceStatus.OK) {
                        if (place.opening_hours) {
                            const daysHours =
                                place.opening_hours.weekday_text.map(e => e.split(/\:\s+/))
                                    .map(e => ({ 'days': e[0].substr(0, 3), 'hours': e[1] }));

                            for (let i = 1; i < daysHours.length; i++) {
                                if (daysHours[i - 1].hours === daysHours[i].hours) {
                                    if (daysHours[i - 1].days.indexOf('-') !== -1) {
                                        daysHours[i - 1].days =
                                            daysHours[i - 1].days.replace(/\w+$/, daysHours[i].days);
                                    } else {
                                        daysHours[i - 1].days += ' - ' + daysHours[i].days;
                                    }
                                    daysHours.splice(i--, 1);
                                }
                            }
                            place.openingHoursSummary = daysHours;
                        }
                        if (place.rating) {
                            const starsOutOfTen = Math.round(2 * place.rating);
                            const fullStars = Math.floor(starsOutOfTen / 2);
                            const halfStars = fullStars !== starsOutOfTen / 2 ? 1 : 0;
                            const emptyStars = 5 - fullStars - halfStars;

                            // Express stars as arrays so details rendering can stay simple.
                            place.fullStarIcons = initArray(fullStars);
                            place.halfStarIcons = initArray(halfStars);
                            place.emptyStarIcons = initArray(emptyStars);
                        }
                        if (place.price_level) {
                            place.dollarSigns = initArray(place.price_level);
                        }
                        if (place.website) {
                            const url = getHttpUrl(place.website);
                            if (url) {
                                place.websiteDomain = url.hostname;
                            } else {
                                place.website = null;
                            }
                        }

                        context.place = place;
                    }
                    showRenderedDetails(context);
                });
            } else {
                showRenderedDetails(context);
            }
        };
    }


function getStoreLocatorConfiguration(rootEl) {
  const configScript = rootEl.querySelector('[data-store-locator-config]');
  if (!configScript) {
    return null;
  }

  try {
    return JSON.parse(configScript.value || configScript.textContent || 'null');
  } catch (error) {
    console.error('[store-locator] Invalid configuration JSON.', error);
    return null;
  }
}

function isStoreLocatorReady() {
  return (
    document.readyState !== 'loading' &&
    window.__storeLocatorMapReady === true &&
    !!window.google &&
    !!window.google.maps
  );
}

function getStoreLocatorRoots(scope = document) {
  const root = scope.matches?.('[data-section-type="store-locator"]')
    ? scope
    : null;
  const descendants = Array.from(scope.querySelectorAll?.('[data-section-type="store-locator"]') || []);
  return root ? [root, ...descendants] : descendants;
}

function initializeStoreLocator() {
  getStoreLocatorRoots().forEach((rootEl) => {
    const configuration = getStoreLocatorConfiguration(rootEl);
    const mapEl = rootEl.querySelector('[data-store-locator-map]');

    if (
      !configuration ||
      !mapEl ||
      !window.__storeLocatorMapReady ||
      !window.google ||
      !window.google.maps
    ) {
      return;
    }

    if (mapEl.dataset.storeLocatorInitialized === 'true') {
      return;
    }

    mapEl.dataset.storeLocatorInitialized = 'true';
    rootEl.storeLocatorInstance = new LocatorPlus(configuration, rootEl);
  });
}

let googleMapsScriptPromise = null;

function loadGoogleMapsScript(rootEl) {
  if (window.google?.maps) {
    window.__storeLocatorMapReady = true;
    return Promise.resolve();
  }

  if (googleMapsScriptPromise) {
    return googleMapsScriptPromise;
  }

  const apiKey = rootEl.dataset.storeLocatorGoogleMapsApiKey;
  if (!apiKey) {
    return Promise.resolve();
  }

  googleMapsScriptPromise = new Promise(function (resolve, reject) {
    window.initStoreLocatorMap = function () {
      window.__storeLocatorMapReady = true;
      window.dispatchEvent(new Event('store-locator:maps-ready'));
      initializeStoreLocator();
      resolve();
    };

    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(apiKey)}&callback=initStoreLocatorMap&libraries=places,geometry&solution_channel=GMP_QB_locatorplus_v4_cABCDE`;
    script.async = true;
    script.defer = true;
    script.onerror = reject;
    document.head.appendChild(script);
  });

  return googleMapsScriptPromise;
}

function scheduleStoreLocatorInitialization(rootEl) {
  if (!rootEl) {
    getStoreLocatorRoots().forEach(scheduleStoreLocatorInitialization);
    return;
  }

  loadGoogleMapsScript(rootEl).then(function () {
    if (isStoreLocatorReady()) {
      initializeStoreLocator();
    }
  }).catch(function (error) {
    console.error('[store-locator] Google Maps failed to load.', error);
  });
}

function destroyStoreLocatorSection(rootEl) {
  const storeLocatorRoot = rootEl.matches('[data-section-type="store-locator"]')
    ? rootEl
    : rootEl.querySelector('[data-section-type="store-locator"]');

  if (!storeLocatorRoot?.storeLocatorInstance) {
    return;
  }

  storeLocatorRoot.storeLocatorInstance.destroy();
  storeLocatorRoot.storeLocatorInstance = null;

  const mapEl = storeLocatorRoot.querySelector('[data-store-locator-map]');
  if (mapEl) {
    delete mapEl.dataset.storeLocatorInitialized;
  }
}

window.initStoreLocatorMap = function () {
  window.__storeLocatorMapReady = true;
  window.dispatchEvent(new Event('store-locator:maps-ready'));
  initializeStoreLocator();
};

window.addEventListener('store-locator:maps-ready', function () {
  initializeStoreLocator();
});

function observeStoreLocatorSections(scope = document) {
  const roots = getStoreLocatorRoots(scope).filter(function (rootEl) {
    return rootEl.dataset.storeLocatorObserved !== 'true';
  });

  if (!roots.length) return;

  if (!('IntersectionObserver' in window)) {
    roots.forEach(scheduleStoreLocatorInitialization);
    return;
  }

  const observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;

      observer.unobserve(entry.target);
      scheduleStoreLocatorInitialization(entry.target);
    });
  }, { rootMargin: '300px 0px' });

  roots.forEach(function (rootEl) {
    rootEl.dataset.storeLocatorObserved = 'true';
    observer.observe(rootEl);
  });
}

document.addEventListener('shopify:section:load', function (event) {
  observeStoreLocatorSections(event.target);
});
document.addEventListener('shopify:section:unload', function (event) {
  destroyStoreLocatorSection(event.target);
});

if (document.readyState === 'loading') {
  window.addEventListener('DOMContentLoaded', function () {
    observeStoreLocatorSections();
  }, { once: true });
} else {
  observeStoreLocatorSections();
}
